import { render, staticRenderFns } from "./yc-profit.vue?vue&type=template&id=0e92358c&scoped=true&"
import script from "./yc-profit.vue?vue&type=script&lang=js&"
export * from "./yc-profit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e92358c",
  null
  
)

export default component.exports